"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeReportLog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Entry_1 = require("./Entry");
const constants_1 = require("../../constants");
const translate_1 = require("../../translate");
const ActionCard_1 = require("../ActionCard");
const Div_1 = require("../Div");
const Flex_1 = require("../Flex");
const Timeline = (0, styled_1.default)(Div_1.Div)({
    width: 2,
    height: '100%',
    background: constants_1.Color.DARK_MEDIUM_GREY,
    position: 'absolute',
    left: 23,
    zIndex: 0,
});
const TimeReportLog = (props) => {
    const t = (0, translate_1.useTranslations)();
    // Reports are returned from backend from newest to oldest
    const ascendingReports = [...props.reports].reverse();
    return ((0, jsx_runtime_1.jsxs)(ActionCard_1.ActionCard, { as: "plain", width: 295, children: [(0, jsx_runtime_1.jsx)(ActionCard_1.ActionCard.Header, { title: t.timesheets.time_report_log() }), (0, jsx_runtime_1.jsx)(ActionCard_1.ActionCard.Body, { styles: {
                    borderTop: constants_1.theme.border.style.thinLight,
                    overflowY: 'auto',
                    maxHeight: 350,
                    paddingBottom: constants_1.theme.spacing[2],
                }, children: (0, jsx_runtime_1.jsxs)(Flex_1.Flex, { col: true, gap: 3.5, styles: { position: 'relative', px: 2 }, children: [(0, jsx_runtime_1.jsx)(Timeline, {}), (0, jsx_runtime_1.jsx)(Div_1.Div, { styles: { height: constants_1.theme.spacing[1] } }), ascendingReports.map((report, index) => ((0, jsx_runtime_1.jsx)(Entry_1.Entry, { previousReport: ascendingReports[index - 1], report: report }, report.id)))] }) })] }));
};
exports.TimeReportLog = TimeReportLog;
